import React, { FunctionComponent, SVGProps } from 'react'

export const IconTelegram: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="26"
    height="22"
    viewBox="0 0 26 22"
    fill="#FCFCFC"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.43425 9.57357C9.0109 6.60998 13.3964 4.65621 15.5906 3.71224C21.8558 1.01702 23.1576 0.548828 24.0061 0.533368C24.1927 0.529968 24.61 0.577804 24.8803 0.804649C25.1085 0.996193 25.1713 1.25494 25.2014 1.43654C25.2314 1.61815 25.2689 2.03185 25.2391 2.3551C24.8996 6.04465 23.4306 14.9982 22.6832 19.1306C22.3669 20.8791 21.7443 21.4654 21.1414 21.5228C19.8313 21.6475 18.8365 20.6273 17.5676 19.767C15.5821 18.4208 14.4603 17.5828 12.533 16.2692C10.3057 14.7511 11.7496 13.9167 13.0189 12.5531C13.3511 12.1962 19.1234 6.76584 19.2351 6.27322C19.2491 6.21161 19.2621 5.98196 19.1302 5.86069C18.9983 5.73942 18.8036 5.78089 18.6631 5.81387C18.4639 5.86062 15.292 8.02905 9.14721 12.3192C8.24686 12.9586 7.43135 13.2702 6.70068 13.2538C5.89518 13.2358 4.34571 12.7828 3.19385 12.3955C1.78103 11.9205 0.658158 11.6694 0.755935 10.8627C0.806864 10.4425 1.3663 10.0128 2.43425 9.57357Z"
    />
  </svg>
)
